<div class="main">
    <!-- メインコンテンツ -->
    <a id="jump-top"></a>
    <div class="main-content">
      <div class="contact p-col-12 card pb-3">
        <div class="p-col-12 head">【プライバシーポリシー】</div>
        <p-divider type="solid"></p-divider>
        <div class="p-col-12 p-pt-3 p-pb-3">「福岡県中高生と乳幼児のふれあい体験マッチングシステム『コドモミライコネクト』」（以下「本サイト」という。）では、個人情報の収集・利用・管理について、「福岡県個人情報の保護に関する法律施行条例」に基づき、次のとおり適切に取り扱うとともに、皆さまに安心して利用いただけるよう努めます。</div>
        <div class="page-title">
					<label class="name">１．基本的な考え方
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトの管理者は、本サイトにおいて提供するサービスの円滑な運営に必要な範囲で、本サイトを利用される皆さまの情報を収集しています。収集した情報は利用目的の範囲内で適切に取り扱います。</div>
        <div class="page-title">
					<label class="name">２．個人情報とは
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトにおける個人情報とは、氏名、e-mailアドレス、勤務先等の、特定の個人を識別できる情報をいいます。</div>
        <div class="page-title">
					<label class="name">３．個人情報の取得
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトでは提供するサービスの円滑な運営に必要な範囲で、本サイトを利用される皆さまの情報を取得しています。原則的にはご本人の意思による提供（登録）によって情報を取得します。<br>
個人情報をご提供いただけない場合には、サービスの全部又は一部を受けられないことがあります。</div>
        <div class="page-title">
					<label class="name">４．利用目的
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">以下に掲げる利用目的の範囲内で、個人情報を利用します。<br>
 <br>
(1) 本サイトが提供するサービス（本サイトを利用する中学校・高校等と保育所・幼稚園等とのマッチング、本サイト利用者からのマッチング相談対応）を提供するため。<br>
(2) 本サイトが提供するサービスに関するご案内、お問い合わせ等の対応のため。<br>
(3) 本サイトが提供するサービスの改善等に役立てるため。<br>
(4) 上記の利用目的に付随する利用目的のため。</div>
        <div class="page-title">
					<label class="name">５．サービス利用にあたっての第三者への提供
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">「ふれあい体験希望登録画面」において、担当者氏名（任意）を入力いただいた場合に、所属団体（勤務先）や所属団体住所、所属団体電話番号等の情報とあわせて、本サイト利用者に提供されます。</div>
        <div class="page-title">
					<label class="name">６．利用及び提供の制限
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトの管理者は、「個人情報の保護に関する法律」又は「福岡県個人情報の保護に関する法律施行条例」で定める場合を除き、収集した情報を「利用目的」以外の目的のために自ら利用し、又は第三者に提供いたしません。ただし、統計的に処理された本サイトのアクセス情報、利用者属性等の情報については公表することがあります。</div>
        <div class="page-title">
					<label class="name">７．安全確保の措置
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトの管理者は、収集した情報の漏えい、滅失又はき損の防止その他収集した情報の適切な管理のために必要な措置を講じます。なお、本サイトの運用については外部に委託することがありますが、委託先においても収集した情報の適切な管理のための必要な措置を講じます。<br>
本サイトに登録いただいた情報は、暗号化通信（SSL）により保護されています。<br>また、保有する必要のなくなった個人情報については速やかに削除します。</div>
        <div class="page-title">
					<label class="name">８．適用範囲
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本方針は、本サイトにおいてのみ適用され、本サイトからリンクされている他のサイトについては適用されません。</div>
        <div class="page-title">
					<label class="name">９．Googleアナリティクスとクッキー(Cookie)の利用について
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトではサイトの利用状況を把握するため、またサイト品質向上のためにGoogleによるアクセス解析ツール「Googleアナリティクス」を利用しております。「Googleアナリティクス」では「クッキー(Cookie)」を使用し、個人を特定する情報を含まずにログを収集しております。 また、収集されるログは、Google社のプライバシーポリシーに基づいて管理されます。<br>
・Googleアナリティクス　https://www.google.com/intl/ja/analytics/<br>・Googleプライバシーポリシー　https://www.google.co.jp/intl/ja/policies/privacy/<br>ブラウザ設定を変更しクッキーの無効化（保存を行なわないようにする）ことで、これらのログ収集を拒否することができます。<br>
ただし、クッキーの無効化で、本サイトの認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。</div>
        <div class="page-title">
					<label class="name">１０．その他
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本方針を改定することがあります。改定する場合は、本サイトでお知らせします。</div>
        <div class="p-col-12 head">【免責事項・リンク等】</div>
        <p-divider type="sulid"></p-divider>
         <br>
        <div class="page-title">
          <label class="name">１．免責事項について</label>
        </div>
        <div class="p-col-12 p-pt-3 p-pb-3">福岡県は、「福岡県中高生と乳幼児のふれあい体験マッチングシステム『コドモミライコネクト』」（以下「本サイト」という。）についてあらゆる面から細心の注意を払っていますが、情報の信頼性・安全性について一切を保証するものではなく、また利用者が本サイト及び本サイトの情報を利用することによって生じるいかなる損害についても責任を負うものではありません。<br>
福岡県は、予告なしに本サイト上の情報を変更あるいは削除、 本サイトの運用を中断または中止することがあります。<br>また、福岡県は理由の如何にかかわらず、情報の変更ならびに削除、及び本サイトの運用の中断または中止によって生じるいかなる損害についても責任を負うものではありません。あらかじめご了承ください。<br>
また、本サイト上から福岡県以外が管理しているホームページにリンクしている場合がありますが、リンク先のホームページについては福岡県が管理、運営するものではありませんので、その内容の真偽等についても一切責任を負いかねますのでご了承ください。</div>
        <div class="page-title">
          <label class="name">２．著作権について</label>
        </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトに掲載されている文字、写真、イラストなどの個々の情報及び本サイト全体に関する著作権は、原則として福岡県に帰属しています。（ただし、一部の画像等の著作権は、原著作者が所有しています。）<br>
「私的使用のための複製」など著作権法上認められた場合を除き、無断で転載、複製、改変、放送、送信、翻訳、販売、貸与などの利用をすることはできません。</div>
        <div class="page-title">
          <label class="name">３．リンクについて</label>
        </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトへのリンクは自由です。<br>但し、次のようなサイトからのリンクは判明次第、リンクの停止を申し入れすることがあります。<br>
          <ul>
            <li>・公序良俗に反するサイト</li>
            <li>・特定の個人や団体について誹謗中傷や名誉を毀損しているか、その可能性のあるサイト</li>
            <li>・福岡県の信用を損なう可能性のあるサイト</li>
            <li>・その他、福岡県が不適当と判断するサイト</li>
          </ul>
        </div>
        <div class="page-title">
          <label class="name">４．ご利用環境（ブラウザ）について</label>
        </div>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトをご覧になる際には、下記のブラウザ環境でアクセスすることを推奨します。これ以外の環境でご利用いただいた場合、画面表示に若干の違いが出るもしくは正常に動作しない等の現象がおきる可能性があります。<br>
          <ul>
            <li>・Microsoft Edge（デスクトップ版）</li>
            <li>・Google Chrome（デスクトップ版・モバイル版）</li>
            <li>・Safari（モバイル版）</li>
          </ul>
フィーチャーフォン及びInternet Explorerには対応しておりません。ご了承ください。</div>
      </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>
